import InfoIconOutlined from '@cp/src/assets/images/icons/InfoIconOutlined';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import renderSelfCallAfterBeforeBars from './SelfCallAfterBeforebars';
import { CallType } from '../constants';
import { convertTimeToMinutes, getCallTypeClass } from '../utils';
import { AgentCallStats } from '../types';
import cx from 'classnames';
import { DateFormat, getFormatDate } from '@cp/src/utils/DateHelper';

const renderCallRow = (callType: CallType, callData: AgentCallStats) => {
  const {
    totalCallDurationInMinutes,
    callCountBeforeBusinessWindow,
    callCountAfterBusinessWindow,
    businessWindowHourlyBreakup,
    firstCallTimestampEpoch
  } = callData;

  const toShowCallBeforeBusinessWindow =
    callCountBeforeBusinessWindow > 0 && callType === CallType.SelfCall;
  const toShowCallAfterBusinessWindow =
    callCountAfterBusinessWindow > 0 && callType === CallType.SelfCall;
  return (
    <div className="flex flex-row items-center mt-1">
      <div className="w-24 flex flex-col text-left gap-1">
        <div className="flex flex-row gap-1 items-center">
          <Typography variant="p5" color="var(--grayscale-2)">
            {callType}
          </Typography>
          <Tooltip placement="top" hideStrategy="referenceHidden">
            <TooltipTrigger>
              <InfoIconOutlined />
            </TooltipTrigger>

            <TooltipContent className={cx('tooltipWrapper', 'max-w-fit')}>
              {firstCallTimestampEpoch === 0 ? (
                <Typography
                  variant="p5"
                  color="var(--grayscale-3)"
                  className="flex flex-row text-nowrap gap-1"
                >
                  No calls made via {callType} yet
                </Typography>
              ) : (
                <>
                  <Typography
                    variant="p5"
                    color="var(--grayscale-3)"
                    className="flex flex-row text-nowrap gap-1"
                  >
                    You have spent
                    <Typography variant="h6" color="var(--bg-primary)">
                      {convertTimeToMinutes(totalCallDurationInMinutes)}
                    </Typography>
                    calling on {callType}
                  </Typography>
                  <Typography
                    variant="p5"
                    color="var(--grayscale-3)"
                    className="flex flex-row text-nowrap gap-1"
                  >
                    since your first call at
                    <Typography variant="p5" color="var(--bg-primary)">
                      {firstCallTimestampEpoch !== 0
                        ? getFormatDate(firstCallTimestampEpoch * 1000, DateFormat.hh_mm_ss_ampm)
                        : '-'}
                    </Typography>
                  </Typography>
                </>
              )}
            </TooltipContent>
          </Tooltip>
        </div>
        <Typography variant="h6">{convertTimeToMinutes(totalCallDurationInMinutes)}</Typography>
      </div>
      <div className="flex-1 flex w-full h-6 rounded-sm">
        {toShowCallBeforeBusinessWindow &&
          renderSelfCallAfterBeforeBars('before 8am', callCountBeforeBusinessWindow || 0)}
        {Object.entries(businessWindowHourlyBreakup)?.map(([_, callCount], index) => (
          <div
            key={`${callType}-${index}`}
            className={`h-full`}
            style={{ width: `${100 / Object.entries(businessWindowHourlyBreakup)?.length}%` }}
          >
            <Tooltip placement="top">
              <TooltipTrigger>
                <div
                  className={cx('w-full h-full', [
                    index === 0 && callType !== CallType.SelfCall ? 'rounded-l-sm' : '',
                    index === Object.entries(businessWindowHourlyBreakup).length - 1 &&
                    callType !== CallType.SelfCall
                      ? 'rounded-r-sm'
                      : ''
                  ])}
                  style={{ backgroundColor: getCallTypeClass(callCount) }}
                />
              </TooltipTrigger>
              <TooltipContent className={cx('tooltipWrapper', 'flex flex-col items-center')}>
                <Typography variant="p5" color="var(--grayscale-3)">
                  Calls done
                </Typography>
                <Typography variant="h5" color="var(--bg-primary)">
                  {callCount}
                </Typography>
              </TooltipContent>
            </Tooltip>
          </div>
        ))}
        {toShowCallAfterBusinessWindow &&
          renderSelfCallAfterBeforeBars('after 7pm', callCountAfterBusinessWindow || 0)}
      </div>
    </div>
  );
};

export default renderCallRow;
